export const UNGROUPED_CHART_SERIES_NAME = 'default';
export const UNKNOWN_CHART_SERIES_NAME = 'none';

export const formatChartSeriesName = (name: string | null | undefined, unknownLabel: string): string | undefined => {
    if (!name) {
        return undefined;
    }

    const normalized = name.trim().toLowerCase();
    if (!normalized || normalized === UNGROUPED_CHART_SERIES_NAME) {
        return undefined;
    }

    if (normalized === UNKNOWN_CHART_SERIES_NAME) {
        return unknownLabel;
    }

    return name;
};
